import { Flex, ListItem, Text, UnorderedList } from "@chakra-ui/react";
import React from "react";
import { getTransparentBrandColorHex } from "theme/colors";
import { ErrorIcon, SuccessIcon } from "ui/icons";
import { FilterTabs } from "ui/tabs";
import { useCdpIndustryConsiderationRows } from "./data";

const greenBg = getTransparentBrandColorHex("green", 50, 0.5);

type RowProps = {
  isComposableCdp?: boolean;
  title: string;
  description: string;
};

function FeatureItem({ isComposableCdp, title, description }: RowProps) {
  return (
    <ListItem
      display="flex"
      flexDir="column"
      gap="small"
      textStyle="caption1"
      px="small"
      py="bigger"
      _notLast={{ borderBottom: "1px", borderColor: "new.gray.150" }}
    >
      <Text as="span" textStyle="body3" fontWeight="bold">
        {title}
      </Text>

      <Flex gap="smallest">
        {isComposableCdp ? <SuccessIcon color="new.green.700" /> : <ErrorIcon color="new.red.700" />}
        {description}
      </Flex>
    </ListItem>
  );
}

export function ConsiderationsTabs() {
  const rows = useCdpIndustryConsiderationRows();

  return (
    <FilterTabs
      gap="bigger"
      tabs={[
        {
          label: "Composable CDP",
          items: (
            <UnorderedList variant="unstyled" m="0" bg={greenBg} borderRadius="big">
              {rows.map((row) => (
                <FeatureItem
                  key={row.title}
                  isComposableCdp
                  title={row.title}
                  description={row.considerations.composable}
                />
              ))}
            </UnorderedList>
          ),
        },
        {
          label: "Traditional CDP",
          items: (
            <UnorderedList variant="unstyled" m="0">
              {rows.map((row) => (
                <FeatureItem key={row.title} title={row.title} description={row.considerations.traditional} />
              ))}
            </UnorderedList>
          ),
        },
      ]}
    />
  );
}
